import { HttpClient } from '@angular/common/http';
import { AuthService } from './../user/auth.service';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs';
import { ListMetadata } from 'app/models/list-metadata.model';
import { LoyaltyReport, LoyaltyReportData, LoyaltyReportPayload } from 'app/models/loyalty-report.model';

@Injectable()
export class LoyaltyReportService {

  private baseUrl = HttpClientService.BASE_MS_CLUSTERING;

  constructor(
    private http: HttpClientService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<LoyaltyReport>, metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
  
    // HttpParams è immutabile, quindi creiamo un nuovo oggetto con il parametro aggiunto
    params = params.append('report_type', 'PUNTI');
  
    console.log('Params:', params.toString()); // Per verificare che il parametro sia stato aggiunto correttamente
  
    return this.http.getPaged(this.baseUrl + '/reporting/getReportList' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }
  
  getStoreChains() {
    return this.http.get(this.baseUrl + '/toys/getToysAffiliatedList');
  }

  getStoresFromChain(chainId: number) {
    return this.http.get(this.baseUrl + '/toys/getToysAffiliatedChainStore?toysAffiliatedId=' + chainId);
  }

  downloadReport(fileName: string) {
    const requestBody = {'filename': fileName};
    const userCompany = this.authService.user.selectedCompany.toString();
    const token =  `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.httpClient.post(
      this.baseUrl + '/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }

  saveReport(reportData: LoyaltyReportData) {
    const payload = new LoyaltyReportPayload(reportData);
    return this.http.post(`${this.baseUrl}/reporting/createReportExcel?code=${reportData.code}&description=${reportData.description}&flagTotal=${reportData.storeTotal}&flagTotalChain=${reportData.chainTotal}`, payload);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-report.service.ts